import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { User } from 'lucide-react';

const PAGE_TITLES: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/ingest':    'Acquisizione',
  '/inbox':     'Inbox — Review fonti',
  '/library':   'Knowledge Base',
  '/graph':     'Knowledge Graph',
  '/report':    'Genera articolo',
  '/settings':  'Impostazioni',
};

function getPageTitle(pathname: string): string {
  if (pathname.startsWith('/publish/')) return 'Pubblica articolo';
  return PAGE_TITLES[pathname] ?? '';
}

export function TopBar() {
  const { user } = useAuth();
  const location = useLocation();
  const title = getPageTitle(location.pathname);

  return (
    <header className="h-12 shrink-0 bg-gray-900 border-b border-gray-800 flex items-center justify-between px-5">
      <h1 className="text-sm font-semibold text-white">{title}</h1>
      <div className="flex items-center gap-2 text-gray-400 text-xs">
        <User className="w-4 h-4" />
        <span>{user?.email ?? ''}</span>
      </div>
    </header>
  );
}
